var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view==='list'"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  ref: "searchItem",
                  attrs: {
                    "config-module": "225200",
                    "expand-adv": true,
                    "show-simple": false,
                    "custom-search-items": _vm.customSearchItems
                  },
                  on: { advSearchItemCallBack: _vm.queryHandler }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            disabled: !_vm.selectedOne || _vm.hasSelectedMulti,
                            no: "view"
                          },
                          on: { click: _vm.toDetail }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_edit"],
                              expression: "['button_OpenPrice_edit']"
                            }
                          ],
                          attrs: {
                            type: "success",
                            disabled:
                              !_vm.selectedOne ||
                              _vm.hasSelectedMulti ||
                              _vm.isEditDisable,
                            no: "edit"
                          },
                          on: { click: _vm.toEdit }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_edit"],
                              expression: "['button_OpenPrice_edit']"
                            }
                          ],
                          attrs: { type: "primary", no: "add" },
                          on: { click: _vm.toAdd }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_edit"],
                              expression: "['button_OpenPrice_edit']"
                            }
                          ],
                          attrs: {
                            type: "primary",
                            disabled: !_vm.selectedOne || _vm.hasSelectedMulti,
                            no: "copy"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toCopy()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_rpaControl"],
                              expression: "['button_OpenPrice_rpaControl']"
                            }
                          ],
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.isRpaEnabled ||
                              !_vm.selectedOne ||
                              _vm.notRpaStart ||
                              _vm.hasSelectedMulti ||
                              _vm.selectedRowCompleted,
                            no: "start"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toStartRPA()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_StartRPA")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_rpaControl"],
                              expression: "['button_OpenPrice_rpaControl']"
                            }
                          ],
                          attrs: {
                            type: "danger",
                            disabled:
                              !_vm.isRpaEnabled ||
                              !_vm.selectedOne ||
                              !_vm.notRpaStart ||
                              _vm.hasSelectedMulti ||
                              _vm.selectedRowCompleted,
                            no: "suspend"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toSuspendRPA()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SuspendRPA")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_importFinalResult"],
                              expression:
                                "['button_OpenPrice_importFinalResult']"
                            }
                          ],
                          attrs: {
                            type: "primary",
                            disabled: !_vm.selectedOne || _vm.hasSelectedMulti,
                            no: "importFinalResult"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toImportFinalResult()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ImportFinalResult"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_edit"],
                              expression: "['button_OpenPrice_edit']"
                            }
                          ],
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.selectedOne ||
                              _vm.hasSelectedMulti ||
                              _vm.selectedRowCompleted,
                            no: "manuallyExportFile"
                          },
                          on: { click: _vm.toExportFile }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ManuallyExportFile"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_delete"],
                              expression: "['button_OpenPrice_delete']"
                            }
                          ],
                          attrs: {
                            type: "danger",
                            disabled: !_vm.hasSelected || _vm.isDeleteDisable,
                            no: "delete"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toDelete()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { position: "relative" }
                },
                [
                  _c("cargo-ag-grid-wrapper", {
                    staticStyle: { height: "100%" },
                    attrs: {
                      "config-module": "225200",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "show-selected-color": false,
                      "check-sub-record": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "225200",
                      total: _vm.filter.total,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: _vm.fetchDataByPage
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.view === "detail"
        ? _c("open-price-detail", {
            ref: "priceDetail",
            attrs: {
              source: _vm.viewSource,
              "company-codes": _vm.companyCodes,
              lanes: _vm.lanes,
              "eq-sizes": _vm.eqSizes,
              "eq-types": _vm.eqTypes,
              "cargo-types": _vm.cargoTypes,
              seaports: _vm.seaports
            },
            on: { back: _vm.toBack, cancel: _vm.toCancel }
          })
        : _vm._e(),
      _vm.openPriceOplogDialog.visible
        ? _c("open-price-oplog-dialog", {
            attrs: {
              visible: _vm.openPriceOplogDialog.visible,
              "filing-batch-no": _vm.openPriceOplogDialog.filingBatchNo
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.openPriceOplogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.importFinalResultDialog.visible
        ? _c("import-final-result-dialog", {
            attrs: {
              visible: _vm.importFinalResultDialog.visible,
              "batch-uuid": _vm.importFinalResultDialog.batchUuid,
              "filing-batch-no": _vm.importFinalResultDialog.filingBatchNo
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.importFinalResultDialog, "visible", $event)
              },
              importSuccess: function($event) {
                return _vm.toBack(_vm.viewSource)
              },
              viewClick: _vm.onViewClick
            }
          })
        : _vm._e(),
      _vm.view === "view"
        ? _c("open-price-view", {
            ref: "priceView",
            attrs: {
              source: "priceBatch",
              "data-changed": _vm.viewDataChanged,
              "rpa-enabled": _vm.rpaEnabled,
              "company-codes": _vm.companyCodes,
              lanes: _vm.lanes,
              "eq-sizes": _vm.eqSizes,
              "eq-types": _vm.eqTypes,
              "cargo-types": _vm.cargoTypes,
              seaports: _vm.seaports
            },
            on: {
              back: _vm.toBack,
              cancel: _vm.toCancel,
              edit: _vm.edit2View,
              add: _vm.toAdd,
              copy: _vm.toCopy,
              startRpa: _vm.toStartRPA,
              suspendRpa: _vm.toSuspendRPA,
              importFinalResult: _vm.toImportFinalResult,
              exportFile: _vm.toExportFile,
              delete: _vm.toDelete
            }
          })
        : _vm._e(),
      _c("price-view-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.priceViewDialog.visible,
            expression: "priceViewDialog.visible"
          }
        ],
        ref: "priceViewDialog",
        attrs: {
          visible: _vm.priceViewDialog.visible,
          "price-batch": _vm.priceViewDialog.priceBatch
        },
        on: {
          close: function() {
            return (_vm.priceViewDialog.visible = false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }